/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetAdminUserPointsPageListRespVo } from './GetAdminUserPointsPageListRespVo';
import {
    GetAdminUserPointsPageListRespVoFromJSON,
    GetAdminUserPointsPageListRespVoFromJSONTyped,
    GetAdminUserPointsPageListRespVoToJSON,
    GetAdminUserPointsPageListRespVoToJSONTyped,
} from './GetAdminUserPointsPageListRespVo';

/**
 * 
 * @export
 * @interface PageDataGetAdminUserPointsPageListRespVo
 */
export interface PageDataGetAdminUserPointsPageListRespVo {
    /**
     * 当前页
     * @type {number}
     * @memberof PageDataGetAdminUserPointsPageListRespVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof PageDataGetAdminUserPointsPageListRespVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof PageDataGetAdminUserPointsPageListRespVo
     */
    totalRecord?: number;
    /**
     * 列表内容
     * @type {Array<GetAdminUserPointsPageListRespVo>}
     * @memberof PageDataGetAdminUserPointsPageListRespVo
     */
    records?: Array<GetAdminUserPointsPageListRespVo>;
}

/**
 * Check if a given object implements the PageDataGetAdminUserPointsPageListRespVo interface.
 */
export function instanceOfPageDataGetAdminUserPointsPageListRespVo(value: object): value is PageDataGetAdminUserPointsPageListRespVo {
    return true;
}

export function PageDataGetAdminUserPointsPageListRespVoFromJSON(json: any): PageDataGetAdminUserPointsPageListRespVo {
    return PageDataGetAdminUserPointsPageListRespVoFromJSONTyped(json, false);
}

export function PageDataGetAdminUserPointsPageListRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageDataGetAdminUserPointsPageListRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(GetAdminUserPointsPageListRespVoFromJSON)),
    };
}

export function PageDataGetAdminUserPointsPageListRespVoToJSON(json: any): PageDataGetAdminUserPointsPageListRespVo {
    return PageDataGetAdminUserPointsPageListRespVoToJSONTyped(json, false);
}

export function PageDataGetAdminUserPointsPageListRespVoToJSONTyped(value?: PageDataGetAdminUserPointsPageListRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(GetAdminUserPointsPageListRespVoToJSON)),
    };
}

